import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp.js";
import { AssistantApp } from "./AssistantApp.js";
import { OpsApp } from "./OpsApp.js";
import { SalesforceActivationApp } from "./SalesforceActivationApp.js";
import { SalesforceAuthorizationCompleteApp } from "./SalesforceAuthorizationCompleteApp.js";
import { SalesforceAuthorizationErrorApp } from "./SalesforceAuthorizationErrorApp.js";
import "./styles.css";

const retiredWebsitePaths = new Set(["/", "/app", "/assistant"]);

if (retiredWebsitePaths.has(window.location.pathname)) {
  window.location.replace("/workspace");
} else {
  const isAdmin = window.location.pathname.startsWith("/admin");
  const isOperations = window.location.pathname.startsWith("/ops");
  const isSalesforceActivation = window.location.pathname.startsWith("/activate/salesforce");
  const isSalesforceAuthorizationComplete = window.location.pathname === "/auth/salesforce/complete";
  const isSalesforceAuthorizationError = window.location.pathname === "/auth/salesforce/error";
  document.title = isOperations
    ? "AI 助手运营中心"
    : isSalesforceActivation
      ? "AI 助手组织设置"
      : isAdmin
        ? "AI 助手管理"
        : "AI 助手";

  createRoot(document.getElementById("root")!).render(
    <StrictMode>{isOperations
      ? <OpsApp />
      : isSalesforceActivation
        ? <SalesforceActivationApp />
        : isSalesforceAuthorizationComplete
          ? <SalesforceAuthorizationCompleteApp />
          : isSalesforceAuthorizationError
            ? <SalesforceAuthorizationErrorApp />
          : isAdmin
            ? <AdminApp />
            : <AssistantApp />}</StrictMode>
  );
}
